module.exports = __webpack_public_path__ + "img/envelope.45803bf0.svg";